/**
 * Internal files
 */
import { applyModule, applyModules } from "./modules/utils"
import { Hamburger } from "./modules/hamburger";
import { Accordions } from "./blocks/accordions";
import { TestimonialCarousel } from "./blocks/testimonial-carousel";
import { ImageCarousel } from "./blocks/image-carousel";
import { DevelopmentList } from "./blocks/development-list";
import { FloorPlanCarousel } from "./blocks/floor-plan-carousel";
import { DevelopmentCarousel } from "./blocks/development-carousel";
import { DimensionCarousel } from "./blocks/dimension-carousel";
import { GravityForm } from "./blocks/gravity-form";
import { InpageNavigation } from "./blocks/inpage-navigation";
import { ScrollWatcher } from "./modules/scroll-watcher";
import { HomeList } from "./blocks/home-list";

declare var Stickyfill;
declare var jQuery;

if (Stickyfill) {
  let elements = document.querySelectorAll('.sticky');
  Stickyfill.add(elements);
}

new ScrollWatcher(101)

applyModules( '.hamburger',  Hamburger )
applyModules( '.accordions-block', Accordions )
applyModules( '.testimonial-carousel-block.with-swiper', TestimonialCarousel )
applyModules( '.image-carousel-block', ImageCarousel )
applyModules( '.development-list', DevelopmentList )
applyModules( '.floor-plan-tabs-block', FloorPlanCarousel )
applyModules( '.development-carousel', DevelopmentCarousel )
applyModules( '.dimension-carousel-block', DimensionCarousel )
applyModules( '.keystone-form_wrapper', GravityForm )
applyModules( '.inpage-navigation-block', InpageNavigation )
applyModules( '.home-list', HomeList )

;(function($){

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.inpage-link')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        // var $target = $(target);
                        // $target.focus();
                        // if ($target.is(":focus")) { // Checking if the target was focused
                        //     return false;
                        // } else {
                        //     $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        //     $target.focus(); // Set focus again
                        // };
                    });
                }
            }
        });


})(jQuery)
